let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("26l9o")).then(() => parcelRequire('gvE09'));